import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Landing from '@/pages/Landing';
import CreateTicket from '@/pages/CreateTicket';
import ProfessionalView from '@/pages/ProfessionalView';
import ManageTicket from '@/pages/ManageTicket';
import AdminDashboard from '@/pages/AdminDashboard';
import TermsAndConditions from '@/pages/TermsAndConditions';
import ProviderAuthPage from '@/pages/ProviderAuthPage';
import ProviderProfileSetup from '@/pages/ProviderProfileSetup';
import ProvidersPro from '@/pages/ProvidersPro';
import { Toaster } from '@/components/ui/sonner';
import { trackPageView } from '@/utils/analytics';
import { captureUtmParams } from '@/utils/utm';

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    captureUtmParams(location.search);
    trackPageView();
  }, [location.pathname, location.search]);
  return null;
}

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
    requestAnimationFrame(() => window.scrollTo(0, 0));
  }, [pathname, search]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/crear-solicitud" element={<CreateTicket />} />
          <Route path="/profesionales" element={<ProfessionalView />} />
          <Route path="/gestionar/:token" element={<ManageTicket />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/terminos" element={<TermsAndConditions />} />
          <Route path="/provider-auth" element={<ProviderAuthPage />} />
          <Route path="/completar-perfil" element={<ProviderProfileSetup />} />
          <Route path="/providers-pro" element={<ProvidersPro />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
